import { Component, Inject, OnInit } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { Travel } from 'app/models/travel.model';
import { MapboxService } from 'app/services/mapbox/mapbox.service';
import { TravelService } from 'app/services/travel/travel.service';

@Component({
  selector: 'app-travels',
  templateUrl: './travels.component.html',
  styleUrls: ['./travels.component.css']
})
export class TravelsComponent implements OnInit {

  travel: Travel;
  liveTravel: any;
  resumeRouteHeader: {
    vehicle: any, driver: any, initTime: any, eta: any, distance: any
  } = {vehicle: {model: {description: ''}}, driver: '', initTime: '', eta: '', distance: ''};
  constructor(
    public dialogRef: MatDialogRef<TravelsComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any,
    private mapboxService: MapboxService,
    private travelService: TravelService
  ) { }

  ngOnInit() {
    this.liveTravel = {
      completedStops: [],
      initTime: '',

    }
    this.travel = this.data.travel;
    if(this.data.liveTravel){
      this.travelService.getLiveTravels(this.travel.id.toString()).subscribe((result) => {
        console.log('live travel info', result);
        this.liveTravel = result;
        this.liveTravel.initTime = this.liveTravel.initTime.toDate();
        this.liveTravel.endTime = this.liveTravel.endTime ? this.liveTravel.endTime.toDate() : 'Viaje en curso'
      });
    }
    this.buildMap();
  }

  buildMap(){
    
    this.mapboxService.getDirection(this.travel.route.locationsRoute).subscribe((result) => {
      this.mapboxService.buildRouteMap(result, this.travel.route.locationsRoute);
      this.resumeRouteHeader = {
        vehicle: this.travel.route.vehicle,
        driver: this.travel.route.driver,
        initTime: this.travel.initTime,
        // eta: result.routes[0].duration,
        eta: new Date(result.routes[0].duration * 1000).toISOString().substr(11, 8),
        // distance: result.routes[0].distance
        distance: this.distanceInKm(result.routes[0].distance)
      }
    })
  }

  private distanceInKm(distance) {
    let distanceInKm = distance / 1000;
    let t=distanceInKm.toString();
    let regex=/(\d*.\d{0,2})/;
    return t.match(regex)[0];
  }
  

}
